import Header from "./Header.vue";
import Footer from "./Footer.vue";
import Loading from "./Loading.vue";

export default {
  Header,
  Footer,
  Loading
};
